module.exports = __webpack_public_path__ + "img/number2.b02fa742.svg";